var map = {
	"./CDMX-zocalo.jpg": 66556,
	"./Chignahuapan.jpg": 22100,
	"./Cuetzalan-Puebla.jpg": 86496,
	"./Isla-de-Janitzio-Michoacan.jpg": 52096,
	"./San-Andres-Mixquic-CDMX.jpg": 57840,
	"./Tzintzuntzana-Michoacan.jpg": 36300,
	"./Xochimilco.jpg": 8324,
	"./aguascalientes.jpg": 59624,
	"./footer_muertos.jpg": 49404,
	"./hero_muertos.jpg": 98236,
	"./huatla-oaxaca-huehuetones-en-cdmx_optimized.jpg": 12084,
	"./muertos_altar.jpg": 57636,
	"./muertos_altar_2.jpg": 19940,
	"./muertos_carrusel.jpg": 31480,
	"./muertos_carrusel_1.jpg": 484,
	"./muertos_carrusel_2.jpg": 78372,
	"./muertos_carrusel_3.jpg": 88120,
	"./muertos_carrusel_4.jpg": 38944,
	"./muertos_carrusel_5.jpg": 44950,
	"./muertos_evento.jpg": 38647,
	"./muertos_evento_1.jpg": 48068,
	"./muertos_evento_2.jpg": 31052,
	"./muertos_evento_3.jpg": 74028,
	"./muertos_evento_4.jpg": 28648,
	"./muertos_evento_5.jpg": 46128,
	"./muertos_evento_6.jpg": 43884,
	"./muertos_evento_7.jpg": 10032,
	"./real-del-monte.png": 34412,
	"./teotihuacan.jpg": 54528,
	"./tlaxco-tlaxcala.jpg": 86540
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96360;